import Yup from '../validationsLib'

/**
 * Validations rules for login page
 */
export default Yup.object().shape({
    label: Yup.string()
        .required("Label cannot be blank!"),
})
